import React, { useEffect, useState } from "react";
import { getAnswers } from "../api/api";
import "./ShowTemperamentQuestion.css";

const ShowIqQuestion = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [temperamentAnswers, setTemperamentAnswers] = useState([]);

  useEffect(() => {
    const fetchUserData = async () => {
      setIsLoading(true);
      try {
        const userData = localStorage.getItem("currentUser");
        const parsedUserData = JSON.parse(userData);
        const _id = parsedUserData?.id || parsedUserData?._id;
        if (_id) {
          const response = await getAnswers({ user_id: _id });
          console.log("Answers:", response);
          const temperament = response?.data?.iqDetails || [];
          setTemperamentAnswers(temperament);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, []);

  return (
    <div className="temperamentscrollContainer">
      {isLoading ? (
        <div className="temperamentloadingContainer">
          <div className="spinner" />
        </div>
      ) : temperamentAnswers.length === 0 ? (
        <div className="temperamentloadingContainer">
          <p>No temperament answers found.</p>
        </div>
      ) : (
        temperamentAnswers.map((item, index) => (
          <div className="temperamentcard" key={index}>
            <p className="temperamentquestion">
              Q{index + 1}: {item.question}
            </p>
            <p className="temperamentanswer">Answer: {item.selected_answer}</p>
          </div>
        ))
      )}
    </div>
  );
};

export default ShowIqQuestion;
